/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_File_ContentsInputs */

const en_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading file contents...`)
};

const fr_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture du contenu du fichier...`)
};

const de_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiinhalt wird gelesen...`)
};

const it_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettura del contenuto del file...`)
};

const ru_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение содержимого файла...`)
};

const es_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo el contenido del archivo...`)
};

const zh_cn2_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在读取文件内容...`)
};

const ja_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの内容を読み込んでいます...`)
};

const hi_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल की सामग्री पढ़ी जा रही है...`)
};

const pt_pt2_reading_file_contents = /** @type {(inputs: Reading_File_ContentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o conteúdo do arquivo...`)
};

/**
* | output |
* | --- |
* | "Reading file contents..." |
*
* @param {Reading_File_ContentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reading_file_contents = /** @type {((inputs?: Reading_File_ContentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_File_ContentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_reading_file_contents(inputs)
	if (locale === "de") return de_reading_file_contents(inputs)
	if (locale === "it") return it_reading_file_contents(inputs)
	if (locale === "ru") return ru_reading_file_contents(inputs)
	if (locale === "es") return es_reading_file_contents(inputs)
	if (locale === "zh-CN") return zh_cn2_reading_file_contents(inputs)
	if (locale === "ja") return ja_reading_file_contents(inputs)
	if (locale === "hi") return hi_reading_file_contents(inputs)
	if (locale === "pt-PT") return pt_pt2_reading_file_contents(inputs)
	return en_reading_file_contents(inputs)
});